import { render, staticRenderFns } from "./dynamicList.vue?vue&type=template&id=65527aea&scoped=true"
import script from "./dynamicList.vue?vue&type=script&lang=js"
export * from "./dynamicList.vue?vue&type=script&lang=js"
import style0 from "./dynamicList.vue?vue&type=style&index=0&id=65527aea&prod&lang=less"
import style1 from "./dynamicList.vue?vue&type=style&index=1&id=65527aea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65527aea",
  null
  
)

export default component.exports